module.exports = __webpack_public_path__ + "img/assistive-listening-systems.f9e95d6b.svg";